'use strict';
// This file is auto generated by bin/create-constants.js
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'align-center': 'alignCenter',
  'align-justify': 'alignJustify',
  'align-left': 'alignLeft',
  'align-right': 'alignRight',
  'angle-left': 'left',
  'angle-right': 'right',
  bulletDisc: 'bulletDiamond',
  calendar: 'date',
  call: 'calling',
  chain: 'link',
  check: 'success',
  check2: 'success',
  clock: 'time',
  close: 'remove',
  'comment-o': 'comments',
  'comments-o': 'comments',
  contact: 'contacts',
  contacts2: 'contacts',
  copy: 'duplicate',
  cross2: 'remove',
  deal: 'deals',
  dedent: 'outdent',
  document: 'documents',
  'down-angle': 'down',
  'down-arr': 'down',
  embed2: 'code',
  eraser: 'eraseStyles',
  'external-link': 'externalLink',
  eye: 'view',
  'eye-slash': 'hide',
  facebook: 'socialFacebook',
  'facebook-messenger': 'socialFacebookMessenger',
  'file-text': 'file',
  'folder-open': 'folderOpen',
  form: 'forms',
  gear: 'settings',
  google: 'socialGoogle',
  'google-plus': 'socialGoogleplus',
  hamburger: 'listView',
  handshake: 'deals',
  'help-with-circle': 'info',
  layer: 'hubDB',
  'left-angle': 'left',
  'left-arr': 'left',
  'left-arrow': 'previous',
  linkedin: 'socialLinkedin',
  'list-ol': 'numberList',
  'list-ul': 'bulletList',
  lock: 'locked',
  mail: 'email',
  microphone: 'record',
  newspaper: 'blog',
  pen: 'signature',
  pencil: 'edit',
  phone: 'calling',
  photo: 'insertImage',
  pinterest: 'socialPinterest',
  plus: 'add',
  'quotes-left': 'insertQuote',
  'right-angle': 'right',
  'right-arr': 'right',
  'right-arrow': 'next',
  rss: 'socialRss',
  star: 'favorite',
  'star-o': 'favorite',
  tickets: 'ticket',
  trash: 'delete',
  trash2: 'delete',
  twitter: 'socialTwitter',
  'up-angle': 'up',
  'up-arr': 'up',
  'upload-light': 'upload',
  user: 'contacts',
  'warning-triangle': 'warning',
  x: 'remove',
  xing: 'socialXing',
  youtube: 'socialYoutube',
  'zoom-in': 'zoomIn',
  'zoom-out': 'zoomOut'
};
module.exports = exports['default'];